let dinerPath;
// 正式包与测试包部署在同一域名的不同路径下（/diner 与 /test-diner），
// 打包产物完全一致，运行时按当前访问路径判断走正式还是测试地址。
const pathname = window && window.location && window.location.pathname;

if(pathname.indexOf('/test-diner') !== -1) {
    dinerPath = 'test-diner';
}else {
    dinerPath = 'diner';
}

export default dinerPath
